import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, Scroll } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { filter, delay, switchMap } from 'rxjs/operators';
import { SwUpdate } from '@angular/service-worker';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { AuthorizationState } from 'src/app/modules/authorization/store/state';
import { ICompany } from 'src/app/modules/authorization/store/types';
import { Login, Logout } from './modules/authorization/store/actions';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  private subscription$: Subscription = new Subscription();

  constructor(
    private router: Router,
    private viewportScroller: ViewportScroller,
    private swUpdate: SwUpdate,
    private translateService: TranslateService,
    private store: Store,
  ) { }

  ngOnInit() {
    this.restoreScroll();
    this.checkForUpdates();
    this.setLanguage();
    this._checkAutoLogin();
  }

  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }

  private restoreScroll(): void {
    this.subscription$.add(
      this.router.events
        .pipe(
          filter((e: any): e is Scroll => e instanceof Scroll),
          delay(0)
        )
        .subscribe(e => {
          if (e.position) {
            this.viewportScroller.scrollToPosition(e.position);
          } else if (e.anchor) {
            this.viewportScroller.scrollToAnchor(e.anchor);
          } else {
            this.viewportScroller.scrollToPosition([0, 0]);
          }
        })
    );
  }

  private checkForUpdates(): void {
    this.subscription$.add(
      this.swUpdate.available.subscribe(() => {
        console.log('PWA - new version is available.');
        this.swUpdate.activateUpdate().then(() => {
          console.log('PWA - activate update.');
          document.location.reload();
        });
      })
    );
    setInterval(() => this.swUpdate.checkForUpdate(), 60 * 1000);
  }

  private setLanguage(): void {
    this.subscription$.add(
      this.store.select(AuthorizationState.currentCompany)
      .subscribe((company: ICompany) => {
          this.translateService.use((company?.appType === 'TAXI_DRIVER') ? 'taxi-driver' : 'sovereign');
      })
    );
  }

  private _checkAutoLogin() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const refreshToken = urlParams.get('refreshToken');

    if (refreshToken) {
      this.store.dispatch(new Logout())
        .pipe(
          switchMap(() => this.store.dispatch(new Login({ refresh_token: refreshToken })))
        )
        .subscribe(() => this.router.navigateByUrl('/dashboard'));
    }
  }
}
